// import { cloneDeep } from 'lodash';

export const ordersFormating = (newOrders, productId__product) => {
  const orders = {};
  for (const order of newOrders) {
    const { rejected, completed } = order;
    const status = rejected === null && (completed === false || completed === null)
    ? 'pending'
    : rejected === false && (completed === false || completed === null)
      ? 'inprogress'
      : 'ready';

    const newOrder = {
      id: order.id,
      orderId: order.order_id,
      orderCode: `${order.point_id}-${order.order_id.substring(0, 4)}`.toUpperCase(),
      pointId: order.point_id,
      userId: order.user_id,
      orderProducts: {},
      orderDate: order.created_at ?? order.updated_at,
      userDevice: order.user_device,
      discount: 0,
      type: 'order',
      assignee: order.assignee,
      services: order.services,
      status,
      completed: order.completed,
      rejected: order.rejected,
      details: order.details || null,
    };

    const productsOfOrder = Array.isArray(order?.products) ? order.products : [];

    for (const product of productsOfOrder) {
      const productId = product.product_id || product.id;
      const newProduct = {
        productId,
        pointId: order.point_id,
        userId: order.user_id,
        productCode: productId__product[productId].code,
        toppingsIds: product.toppings_ids,
        productCost: productId__product[productId].cost,
        productName: productId__product[productId].name,
        productService: productId__product[productId].service_id,
      };

      if (!newOrder.orderProducts[productId]) {
        newOrder.orderProducts[productId] = [];
      }
      newOrder.orderProducts[productId].push(newProduct);
    }

    orders[order.order_id] = newOrder;
  }

  return orders;
};
